import { openBlock as r, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return r(), t("svg", n, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M3 14h18v2H3zm0-6h18v2H3z"
    }, null, -1)
  ])]);
}
const s = { render: l };
export {
  s as default,
  l as render
};
